import * as React from "react";
import { Button, Grid } from "components/controls/widget";
import { withActionsExecutor, ActionsExecutorPropsType, Action, ActionError } from "components/actions";
import { WithStyles, withStyles, createStyles, Theme } from 'components/controls/styles';
import YesNoDialog, { YesNoDialogProps } from "common/components/controls/YesNoDialog"
import Error from "common/components/controls/Error";
import apiOznameniHostovani from "common/api/SendEmailNotifications/OznameniHostDlouhodobe";
import { Hostovani, PotvrzeniHostovani as apiPotvrzeniHostovaniIc, ZamitnutiHostovani as apiZamitnutiHostovaniIc } from "common/api/Evidence/Clenove/HostovaniDlouhodoba";
import { PotvrzeniHostovani as apiPotvrzeniHostovaniKc, ZamitnutiHostovani as apiZamitnutiHostovaniKc } from "common/api/Evidence/Kluby/HostovaniDlouhodoba";
import HU from "common/utils/HostovaniDlouhodobaUtils";


interface PotvrzeniZamitnutiProps {
    hostovani: Hostovani;
    setHostovani: (hostovani: Hostovani) => void;
    je_to_clen: boolean;
    je_to_dom_klub: boolean;
}


interface State {
    showDialogPotvrzeni: boolean;
    showDialogZamitnuti: boolean;
    submitting?: boolean;
    hasError: boolean;
    error?: React.ReactNode;
}

type Props = PotvrzeniZamitnutiProps & State & ActionsExecutorPropsType;


const initialState: State = {
    showDialogPotvrzeni: false,
    showDialogZamitnuti: false,
    hasError: false,
}



class PotvrzeniZamitnuti extends React.PureComponent<Props & WithStyles<typeof styles>> {

    handleClose = (potvrzeni: boolean, cancel: boolean) => {
        if (cancel) {
            this.showDialog(potvrzeni, false);
        } else {
            const { executeAction, hostovani, je_to_clen } = this.props;
            const action1 = potvrzeni
                ? je_to_clen ? apiPotvrzeniHostovaniIc(hostovani.id) : apiPotvrzeniHostovaniKc(hostovani.id)
                : je_to_clen ? apiZamitnutiHostovaniIc(hostovani.id) : apiZamitnutiHostovaniKc(hostovani.id);

            action1
                .onSuccess(p => {
                    const action2 = apiOznameniHostovani()
                        .onSuccess(() => this.close(potvrzeni, p))
                        .onError(() => this.close(potvrzeni, p));

                    const tz = je_to_clen ? HU.TypZpravy_PotvrzeniIC : HU.TypZpravy_PotvrzeniKC;
                    executeAction(action2, {}, { hostovaniId: p.id, typZpravy: tz })
                })
                .onValidationFailed(e => this.setError(e['_error']))
                .onError(e => this.setError(e.message));

            executeAction(action1, { submitting: true, hasError: false, error: undefined });
        }
    }

    setError = (error: string | string[]) => {
        this.props.updateState({ submitting: false, hasError: true, error: error });
    }

    showDialog = (potvrzeni: boolean, show: boolean) => {
        if (potvrzeni === true) {
            if (this.props.showDialogPotvrzeni !== show) {
                this.props.updateState({ submitting: false, showDialogPotvrzeni: show, hasError: false, error: undefined });
            }

        } else {
            if (this.props.showDialogZamitnuti !== show) {
                this.props.updateState({ submitting: false, showDialogZamitnuti: show, hasError: false, error: undefined });
            }
        }
    }

    close = (potvrzeni: boolean, hostovani: Hostovani) => {
        this.showDialog(potvrzeni, false);
        this.props.setHostovani(hostovani);
    }

    render() {

        const { hostovani, je_to_clen, je_to_dom_klub, setHostovani, showDialogPotvrzeni, showDialogZamitnuti, hasError, error, submitting, classes } = this.props;

        const dlgPropsPotvrzeni: YesNoDialogProps = {
            show: showDialogPotvrzeni,
            submitting: submitting,
            handleClose: cancel => this.handleClose(true, cancel),
            title: 'Potvrzení dlouhodobého hostování',
            fullWidth: true,
            maxWidth: 'sm',
        }

        const dlgPropsZamitnuti: YesNoDialogProps = {
            show: showDialogZamitnuti,
            submitting: submitting,
            handleClose: cancel => this.handleClose(false, cancel),
            title: 'Zamítnutí dlouhodobého hostování',
            fullWidth: true,
            maxWidth: 'sm',
        }

        const zobrazit = (hostovani.stav === HU.Stav_PotvrzeniICaDomKC && ((je_to_clen && !hostovani.dat_potvrz_ic) || (je_to_dom_klub && !hostovani.dat_potvrz_kc)));

        return zobrazit ? <div className={classes.root}>
            <Grid container justify="space-between" direction="row" spacing={8}>
                <Grid item xs={5}>
                    <Button color="success" variant="contained" onClick={() => this.showDialog(true, true)}>{'Potvrdit dlouhodobé hostování'}</Button>
                </Grid>
                <Grid item xs={5}>
                    <Button color="danger" variant="contained" onClick={() => this.showDialog(false, true)}>{'Zamítnout dlouhodobé hostování'}</Button>
                </Grid>
                <Grid item xs={2} />
            </Grid>
            <YesNoDialog {...dlgPropsPotvrzeni}>
                <Grid container justify="space-between" direction="column" spacing={8}>
                    <Grid item>{'Opravdu potvrzujete dlouhodobé hostování?'}</Grid>
                    {hasError && <Grid item><Error noPadding>{error}</Error></Grid>}
                </Grid>
            </YesNoDialog>
            <YesNoDialog {...dlgPropsZamitnuti}>
                <Grid container justify="space-between" direction="column" spacing={8}>
                    <Grid item>{'Opravdu chcete zamítnout dlouhodobé hostování?'}</Grid>
                    {hasError && <Grid item><Error noPadding>{error}</Error></Grid>}
                </Grid>
            </YesNoDialog>
        </div> : null;
    }
}

export const styles = (theme: Theme) => createStyles({
    root: {
        paddingTop: theme.spacing.unit * 2,
        paddingBottom: theme.spacing.unit * 2,
    },
});

export default withStyles(styles)(withActionsExecutor<PotvrzeniZamitnutiProps, State>(initialState, PotvrzeniZamitnuti));
